module.exports = __webpack_public_path__ + "static/wand_of_magic_detection-08bec0345a4679e527e24ff0a683c683.jpeg";